import React, { useMemo, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";

import DataTable from "react-data-table-component";
import { Button, Spinner, Alert, Fade } from "react-bootstrap";
import { format } from "date-fns";
import { Save2 } from "react-bootstrap-icons";

import { EodReportSearchForm } from "./EodReportSearchForm";
import { reportReducerActions } from "..";
import { rtSagaActions, rtReducerActions } from "../../ReceiptTracking";

const XLSX = require('xlsx');

const date = Date().split(" ");
const dateStr = date[2] + date[1] + date[3];

const moneyFormater = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "PGK"
});

const presentDate = new Date();
const formatPresentDate = format(presentDate, "dd/MM/yyyy");

function convertReceiptstoEODArray(receipts){
    let eodFormatValues = receipts.map(rec => (
      {
        //suthzy, 19 Aug, 2025 - Changed docid to rec.id from 1
        docid: rec.id,
        ddate1: rec.rcpt_issued_date,
        dsource: "ER",
        dref1: rec.rcpt_number,
        lineid: 1,
        litemtype: "57401" + rec.service_item_number.substring(0, 3),
        litemcode: rec.service_item_number,
        lamount1: `-${rec.service_item_price}`,
        lnarr1: "ERec Online Payment",
        lnarr2: rec.service_item_desc,
        lnarr3: rec.cust_first_name + " " + rec.cust_last_name,
        bimpname: "EREC_GOV"
      }
    ));
    
    return eodFormatValues;
};

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function convertArrayOfObjectsToCSV(array) {
  let result = "";

  const columnDelimiter = ",";
  const lineDelimiter = "\n";
  let keys = Object.keys(array[0]);

  keys = keys.map((k) => {
    let key = {};
    key.value = k;
    key.name = k.toUpperCase();
    
    return key;
  });
  
  result += "FORMAT BATCH IMPORT  STANDARD 1.0";
  result += lineDelimiter;
  result += keys.map(k => k.name).join(columnDelimiter);
  result += lineDelimiter;
  
  array.forEach((item) => {
    
    let ctr = 0;
    keys.forEach((key) => {
      if (ctr > 0) result += columnDelimiter;

      result += item[key.value];

      ctr++;
    });
    result += lineDelimiter;
  });
  
  return result;
};

// Blatant "inspiration" from https://codepen.io/Jacqueline34/pen/pyVoWr
function downloadCSV(array) {
  if(array.length === 0){
    return
  }
  const link = document.createElement("a");
  let eodformat = convertReceiptstoEODArray(array);
  let csv = convertArrayOfObjectsToCSV(eodformat);
  if (csv == null) return;

  const filename = `EOD Report_${dateStr}.csv`;

  if (!csv.match(/^data:text\/csv/i)) {
    csv = `data:text/csv;charset=utf-8,${csv}`;
  }

  link.setAttribute("href", encodeURI(csv));
  link.setAttribute("download", filename);
  link.click();
};

function downloadEXCEL(array) {
  if(array && array.length === 0){
    return
  }
  let eodFormattedValues = convertReceiptstoEODArray(array);
  let worksheet = XLSX.utils.json_to_sheet(eodFormattedValues);
  var workBook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workBook, worksheet, "EOD Report");

  XLSX.writeFile(workBook, `EOD Report_${dateStr}.xlsx`);
  
};

// function downloadPDFReport(dataStr){
//   if (dataStr){
//     if (dataStr.length === 0){
//       alert("PDF file was not generated.");
//       return;
//     }
//     const filename = `EOD Report_${dateStr}.pdf`;
//     const link = document.createElement("a");
//     let data = 'data:application/pdf;base64,' + dataStr;
//     link.setAttribute("href", data);
//     link.setAttribute("download", filename);
//     link.click();
//   } else {
//     alert("PDF file was not generated.");
//     return
//   }
// };

const Export = ({ onCSVExport, onPDFExport, onExcelExport, reportLoading }) => (
  <>
    <Button variant="primary" onClick={(e) => onCSVExport(e.target.value)} style={{fontSize: "14px"}}><Save2 /> &nbsp; Export to CSV</Button>{" "}
    {/* <Button variant="primary" onClick={(e) => onPDFExport(e.target.value)} style={{fontSize: "14px"}} disabled={reportLoading} >PDF</Button>{" "} */}
    <Button variant="primary" onClick={(e) => onExcelExport(e.target.value)} style={{fontSize: "14px"}}><Save2 /> &nbsp; Export to EXCEL</Button>
  </>
);

const columns = [
  {
    name: "Receipt No.",
    selector: (row) => row.rcpt_number,
    sortable: true,
  },
  {
    name: "Status",
    selector: (row) => row.rcpt_status_desc,
    sortable: true,
  },
  {
    name: "Customer",
    selector: (row) => row.cust_first_name + " " + row.cust_last_name,
    sortable: true,
  },
  {
    name: "Service Type",
    selector: (row) => row.service_name,
    sortable: true,
  },
  {
    name: "Service Item",
    selector: (row) => row.service_desc,
    sortable: true,
  },
  {
    name: "Mobile",
    selector: (row) => row.cust_msisdn,
    sortable: true,
  },
  {
    name: "Department",
    selector: (row) => row.dept_name,
    sortable: true,
  },
  {
    name: "Province",
    selector: (row) => row.province_name,
    sortable: true
  },
  {
    name: "Amount",
    selector: (row) => moneyFormater.format(row.total_amnt),
    sortable: true
  },
  {
    name: "Date Issued",
    selector: (row) => row.rcpt_issued_date,
    sortable: true
  }
];

const dataTableStyles = {
  rows: {
    style: {
      fontSize: "15px"
    },
  },
  headCells: {
    style: {
      fontSize: "16px"
    },
  },
  cells: {
    style: {
      fontSize: "15px"
    },
  },
  pagination: {
    style: {
      fontSize: "16px"
    }
  }
};

export function EodReportTable() {

  const dispatch = useDispatch();

  const { reports, receiptTracking } = useSelector(state => state);
 
  const { /*reportDataString,*/ fetchingReportStr } = reports;
  const { masterReceipts, listLoading:rtListLoading, receiptsMaxLimit, receiptMaxErrorMsg } = receiptTracking;

  const [ showRcptLimitErr, setShowRcptLimitErr ] = useState(false);
  
  const [ resetPagination, setResetPagination ] = useState(false);

  const [ reportTitle, setReportTitle ] = useState("Receipts Generated Today");
  
  const actionsMemo = useMemo(() => 
    <Export 
    //   onPDFExport={() => downloadPDFReport(reportDataString)} 
      onCSVExport={() => downloadCSV(masterReceipts)} 
      onExcelExport={() => downloadEXCEL(masterReceipts)}
      reportLoading={fetchingReportStr} 
    />,
  [masterReceipts, fetchingReportStr]);

  useEffect(() => {
    dispatch(rtSagaActions.fetchMasterReceipts({ 
      fromIssuedDate: formatPresentDate,
      toIssuedDate: formatPresentDate
    }));
  }, [dispatch]);

  useEffect(() => {
    if(receiptsMaxLimit){
      setShowRcptLimitErr(true);
      setTimeout(() => {
        dispatch(rtReducerActions.clearReceiptMaxLimit());
        setShowRcptLimitErr(false);
      }, 8000);
    } else {
      setShowRcptLimitErr(false);
    }
  }, [receiptsMaxLimit, dispatch, receiptMaxErrorMsg]);

  const closeAlert = () => {
    dispatch(rtReducerActions.clearReceiptMaxLimit());
    setShowRcptLimitErr(false);
  };

  const handleReportReset = () => {
    dispatch(rtSagaActions.fetchMasterReceipts({
      fromIssuedDate: formatPresentDate,
      toIssuedDate: formatPresentDate
    }));
    setReportTitle("Receipts Generated Today");
  };

  
  const handleReportRequest = (queryParams) => {
    setResetPagination(true);
    dispatch(reportReducerActions.reportStateClear());
    dispatch(reportReducerActions.reportStringCleared());

    let newQueryParams = { 
      fromIssuedDate: queryParams.p_fromDate, 
      toIssuedDate: queryParams.p_toDate,
      departmentId: queryParams.p_departmentId, 
      serviceId: queryParams.p_serviceTypeId,
      serviceItemId: queryParams.p_serviceItemId,
      provinceId: queryParams.p_provinceId
    };
    
    dispatch(rtSagaActions.fetchMasterReceipts(newQueryParams));
    setResetPagination(false);
    setReportTitle("Filtered Reciepts");
    
  };

  return (
    <div className="card card-custom card-stretch gutter-b">
      {/* begin::Header */}

      {/* end::Header */}

      {/* begin::Body */}

      {
        showRcptLimitErr ?
        <div className="d-flex justify-content-end">
          <Alert variant="info" transition={Fade} onClose={closeAlert} dismissible style={{ width: "50%", zIndex: 2, position: "absolute" }} >
            <Alert.Heading > Maximum Receipt Records Reached </Alert.Heading>
            <p>
              <b> {receiptMaxErrorMsg} </b>
              <br/>
              Adjust your search parameters to make a narrow or specific search for receipt records.
            </p>
          </Alert>
        </div>
        : null  
      }
      
      <div className="card-body py-6">
        <div className="row justify-content-start">
          <div className="col-12">
            <EodReportSearchForm onHandleReportRequest={handleReportRequest} onHandleReset={handleReportReset} />
          </div>
        </div>
        <div className="row pt-10">
          <div className="col-12">
            <DataTable
              title={reportTitle}
              customStyles={dataTableStyles}
              columns={columns}
              data={masterReceipts}
              actions={actionsMemo}
              progressPending={rtListLoading}
              progressComponent={<Spinner variant="primary" animation="border" />}
              pagination
              paginationResetDefaultPage={resetPagination}
            />
            {/* end::Table */}
          </div>
        </div>
      </div>
      {/* end::Body */}
    </div>
  );
}
